import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { AnnouncementsApiClient, announcementsApiRef } from './api/AnnouncementsApi';

export const announcementsPlugin = createPlugin({
  id: 'announcements',
  apis: [
    createApiFactory({
      api: announcementsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AnnouncementsApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AnnouncementsPage = announcementsPlugin.provide(
  createRoutableExtension({
    name: 'AnnouncementsPage',
    component: () =>
      import('./components/AnnouncementsPage/AnnouncementsPage').then(m => m.AnnouncementsPage),
    mountPoint: rootRouteRef,
  }),
);

export const AnnouncementsCard = announcementsPlugin.provide(
  createComponentExtension({
    name: 'AnnouncementsCard',
    component: {
      lazy: () =>
        import('./components/AnnouncementsCard/AnnouncementsCard').then(
          m => m.AnnouncementsCard,
        ),
    },
  }),
);

export const AnnouncementsPopup = announcementsPlugin.provide(
  createComponentExtension({
    name: 'AnnouncementsPopup',
    component: {
      lazy: () =>
        import('./components/AnnouncementsPopup/AnnouncementsPopup').then(
          m => m.AnnouncementsPopup,
        ),
    },
  }),
);

export const AdminAnnouncementsPage = announcementsPlugin.provide(
  createRoutableExtension({
    name: 'AnnouncementsPage',
    component: () =>
      import('./components/AdminAnnouncementsPage/AdminAnnouncementsPage').then(m => m.AdminAnnouncementsPage),
    mountPoint: rootRouteRef,
  }),
);
